import { useDispatch } from 'react-redux';
import { ActionType, FeatureFlag } from '@mews-commander/enums';
import { CommanderThunkDispatch } from '@mews-commander/types';
import { setShouldRestoreScroll } from '@mews-commander/ui';
import { getNormalizedPathname, useFeatureFlag, useLoggerService } from '@mews/framework';
import { push } from '@mews/routing';
import { IconName } from '@optimus-web/icons';
import { HeadingAction } from '../../legacy/React/Components/HeadingAction/Action/types';
import { popHistory, setNavigatedBack, useHasHistory } from '../history';

export const useCloseButton = (): HeadingAction | null => {
    const loggerService = useLoggerService();
    const dispatch: CommanderThunkDispatch = useDispatch();
    const hasHistory = useHasHistory();

    const areCustomBackArrowsDisabled = useFeatureFlag(FeatureFlag.customBackArrowsDisabled);
    if (areCustomBackArrowsDisabled) {
        return null;
    }

    return hasHistory
        ? {
              type: ActionType.Link,
              icon: IconName.ArrowLeft,
              'data-test-icon-button': IconName.CrossClose,
              onClick: () => {
                  const closedUrl = getNormalizedPathname(window);

                  const url = popHistory();
                  setNavigatedBack(true);
                  dispatch(push(url));
                  setShouldRestoreScroll(true);

                  loggerService.log('close-modal', 'Close modal button was clicked on', {
                      currentUrl: getNormalizedPathname(window),
                      closedUrl,
                  });
              },
          }
        : null;
};
